var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgG(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 58,
    r: 58,
    fill: "url(#paint0_linear_721_17061)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 58,
    r: 41,
    fill: "#02A3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.125 61.125H67.875V69.875H66.125V61.125Z",
    fill: "#FFF1F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.125 36.625H34.625V41.875H80.125V36.625ZM38.125 40.125H36.375V38.375H38.125V40.125ZM41.625 40.125H39.875V38.375H41.625V40.125ZM45.125 40.125H43.375V38.375H45.125V40.125Z",
    fill: "#FFF1F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.875 70.75V68.125H42.5C41.0527 68.125 39.875 69.3027 39.875 70.75V84.75C39.875 86.1973 41.0527 87.375 42.5 87.375H60C61.4473 87.375 62.625 86.1973 62.625 84.75V74.25H62.652C61.5801 73.452 60.875 72.1859 60.875 70.75H60.875ZM48.369 82.381L47.1319 83.6181L41.2631 77.7497L47.1319 71.8809L48.369 73.118L43.7374 77.7496L48.369 82.381ZM50.342 84.1154L48.6584 83.6341L52.1584 71.3841L53.842 71.8654L50.342 84.1154ZM55.369 83.6185L54.1319 82.3814L58.7631 77.7498L54.1319 73.1186L55.369 71.8815L61.2374 77.7499L55.369 83.6185Z",
    fill: "#FFF1F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.875 66.375V56.75C60.875 54.3375 62.8375 52.375 65.25 52.375H80.125V43.625H34.625V71.625H38.125V70.75C38.125 68.3375 40.0875 66.375 42.5 66.375H60.875ZM76.625 45.375H78.375V47.125H76.625V45.375ZM73.125 45.375H74.875V47.125H73.125V45.375ZM69.625 45.375H71.375V47.125H69.625V45.375ZM36.375 64.625V45.375H59.125V64.625H36.375Z",
    fill: "#FFF1F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.125 62.875H57.375V47.125H38.125V62.875ZM45.125 61.125H43.375V59.375H45.125V61.125ZM48.625 61.125H46.875V59.375H48.625V61.125ZM52.125 61.125H50.375V59.375H52.125V61.125ZM55.625 61.125H53.875V59.375H55.625V61.125ZM39.875 48.875H55.625V50.625H39.875V48.875ZM39.875 52.375H55.625V54.125H39.875V52.375ZM39.875 55.875H55.625V57.625H39.875V55.875Z",
    fill: "#FFF1F1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.75 54.125H65.25C63.8027 54.125 62.625 55.3027 62.625 56.75V70.75C62.625 72.1973 63.8027 73.375 65.25 73.375H82.75C84.1973 73.375 85.375 72.1973 85.375 70.75V56.75C85.375 55.3027 84.1973 54.125 82.75 54.125ZM83.625 71.625H64.375V59.375H69.625V69.875H71.375V62.875H76.625V69.875H78.375V55.875H83.625V71.625Z",
    fill: "#FFF1F1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.125 57.625H81.875V69.875H80.125V57.625Z",
    fill: "#FFF1F1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.125 64.625H74.875V69.875H73.125V64.625Z",
    fill: "#FFF1F1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_721_17061",
    x1: 58,
    y1: 0,
    x2: 58,
    y2: 116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A3FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgG);
export default __webpack_public_path__ + "static/media/g.e7a6bbcc8f19b0fc09a21d344099a88d.svg";
export { ForwardRef as ReactComponent };